import { FC } from 'react';

export interface ICloseIconProps {
  className?: string;
  height?: number;
  width?: number;
}

export const CloseIcon: FC<ICloseIconProps> = ({ className, height, width }) => {
  const customClass = className ? ` ${className}` : '';
  const iconHeight = height ?? 17;
  const iconWidth = width ?? 17;
  return (
    <svg
      role="img"
      className={`close-icon${customClass}`}
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 17 17"
      data-testid="close-icon"
      xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="m0,0l17,17" stroke="currentColor" />
      <path fill="currentColor" d="m17,0l-17,17" stroke="currentColor" />
    </svg>
  );
};

export default CloseIcon;
